import { api } from './client';

type Envelope<T> = { data: T };

export type RecipientRole = 'signer' | 'approver' | 'cc' | 'witness' | 'for_info';
export type RecipientStatus = 'pending' | 'sent' | 'viewed' | 'signed' | 'declined' | 'expired';
export type RecipientAuthMethod = 'email_otp' | 'sms_otp' | 'access_code' | 'asan_imza' | 'none';

export type Recipient = {
  id: string;
  envelopeId: string;
  email: string;
  name: string;
  role: RecipientRole;
  signingOrder: number;
  authMethod: RecipientAuthMethod;
  status: RecipientStatus;
  phone: string | null;
  customMessage: string | null;
  hasAccessCode: boolean;
  signedAt: string | null;
  declinedAt: string | null;
  declineReason: string | null;
  viewedAt: string | null;
  createdAt: string;
};

export type CreateRecipientInput = {
  email: string;
  name: string;
  role?: RecipientRole;
  signingOrder?: number;
  authMethod?: RecipientAuthMethod;
  accessCode?: string;
  phone?: string;
  customMessage?: string;
};

export const recipientsApi = {
  async list(envelopeId: string): Promise<Recipient[]> {
    const { data } = await api.get<Envelope<Recipient[]>>(`/envelopes/${envelopeId}/recipients`);
    return data.data;
  },

  async create(envelopeId: string, input: CreateRecipientInput): Promise<Recipient> {
    const { data } = await api.post<Envelope<Recipient>>(
      `/envelopes/${envelopeId}/recipients`,
      input,
    );
    return data.data;
  },

  async update(uuid: string, input: Partial<CreateRecipientInput>): Promise<Recipient> {
    const { data } = await api.patch<Envelope<Recipient>>(`/recipients/${uuid}`, input);
    return data.data;
  },

  async remove(uuid: string): Promise<void> {
    await api.delete(`/recipients/${uuid}`);
  },

  async reorder(
    envelopeId: string,
    items: Array<{ id: string; signingOrder: number }>,
  ): Promise<Recipient[]> {
    const { data } = await api.patch<Envelope<Recipient[]>>(
      `/envelopes/${envelopeId}/recipients/reorder`,
      { recipients: items },
    );
    return data.data;
  },
};
